module.exports = __webpack_public_path__ + "img/sertifikasi_kompetensi.fa51034e.png";